import type { TourDefinition } from "@/config/tours";

import { billingAdminTrainingTours } from "./billing-admin";
import { clinicalTrainingTours } from "./clinical";
import { schedulingTrainingTours } from "./scheduling";

/**
 * Tours behind each training task's "Show me". Names match `tour` on the tasks in
 * `decoda/training/tasks.py`; the task's screen is opened before the tour starts.
 */
export const trainingTours: TourDefinition[] = [
  ...schedulingTrainingTours,
  ...clinicalTrainingTours,
  ...billingAdminTrainingTours,
];
